// 报名审核状态（audit_status）统一口径：与后台字典 exam_registration_audit_status 保持一致。
// 统一在此维护，避免考生端各页面各写一套映射，导致状态漏映射被显示成“已提交”等问题。
// 0 待线上资格审查 / 1 待线下资格审查 / 2 审核通过 / 3 线上资格审查驳回 /
// 4 线下资格审查驳回 / 5 不符合条件 / 6 线上审核通过，线下未到场
export const AUDIT_STATUS_TEXT = {
  0: "待线上资格审查",
  1: "待线下资格审查",
  2: "审核通过",
  3: "线上资格审查驳回",
  4: "线下资格审查驳回",
  5: "不符合条件",
  6: "线上审核通过，线下未到场",
};

// 状态对应 el-tag 配色
const AUDIT_STATUS_TAG_TYPE = {
  0: "warning",
  1: "warning",
  2: "success",
  3: "danger",
  4: "danger",
  5: "danger",
  6: "warning",
};

/** 提交状态是否已提交（1 已提交，其它为草稿） */
const isSubmitted = (submitStatus) =>
  submitStatus === undefined || submitStatus === null || Number(submitStatus) === 1;

/**
 * 审核状态文案
 * @param {number|string} auditStatus 审核状态 audit_status
 * @param {number|string} [submitStatus] 提交状态，传入且非 1 时返回“未提交”
 */
export const getAuditStatusText = (auditStatus, submitStatus) => {
  if (!isSubmitted(submitStatus)) return "未提交";
  const s = Number(auditStatus);
  return AUDIT_STATUS_TEXT[s] || "已提交";
};

/**
 * 审核状态标签配色（el-tag type）
 * @param {number|string} auditStatus 审核状态 audit_status
 * @param {number|string} [submitStatus] 提交状态，传入且非 1 时返回 info
 */
export const getAuditStatusTagType = (auditStatus, submitStatus) => {
  if (!isSubmitted(submitStatus)) return "info";
  const s = Number(auditStatus);
  return AUDIT_STATUS_TAG_TYPE[s] || "primary";
};

export default {
  AUDIT_STATUS_TEXT,
  getAuditStatusText,
  getAuditStatusTagType,
};
